import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function ResetExecutado({ status, onAtualizar }) {
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const cfg = status.config || {};
  const logs = (status.logs || []).filter((l) => l.execucao_id === cfg.execucao_id);
  const exec = logs.find((l) => l.acao === "executar");
  const nota = logs.find((l) => l.acao === "nota_correcao_arquivos");
  const precisaNota = !nota && (exec?.arquivos || []).some((a) => a.resultado === "ja_ausente");

  const registrar = async () => {
    setEnviando(true);
    setErro("");
    try {
      await api.post("/admin/reset-financeiro/nota-arquivos", { execucao_id: cfg.execucao_id });
      onAtualizar?.();
    } catch (e) {
      setErro(e?.response?.data?.detail || "Não foi possível registrar a nota.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-5 mb-8 text-sm space-y-3" data-testid="reset-ja-executado">
      <div>
        Reset executado em {cfg.reset_executado_em} · execução <span className="font-mono">{cfg.execucao_id}</span>
        {" "}· cópia técnica até {cfg.backup_expira_em}
      </div>
      {exec?.arquivos?.length > 0 && (
        <ul className="list-disc pl-5" data-testid="reset-arquivos-registro">
          {exec.arquivos.map((a) => (
            <li key={a.caminho} className="break-all">{a.arquivo_nome}: registro original <b>{a.resultado}</b></li>
          ))}
        </ul>
      )}
      {nota && (
        <div className="bg-white border border-emerald-200 rounded p-3" data-testid="reset-nota-arquivos">
          <b>Nota de correção ({nota.quando}):</b> {nota.nota}
        </div>
      )}
      {precisaNota && (
        <Button onClick={registrar} disabled={enviando} variant="outline" data-testid="reset-nota-arquivos-btn">
          {enviando ? "Registrando…" : "Registrar nota de correção dos arquivos"}
        </Button>
      )}
      {erro && <p className="text-red-700" data-testid="reset-nota-erro">{erro}</p>}
    </div>
  );
}
